const raw = import.meta.env

function toNumber(value: string | undefined, fallback: number) {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

export const env = {
  appName: raw.VITE_APP_NAME || 'ALFI Admin',
  appEnv: raw.VITE_APP_ENV || 'local',
  apiBaseUrl: `${(raw.VITE_API_BASE_URL || '').replace(/\/+$/, '')}/v1`,
  apiTimeoutMs: toNumber(raw.VITE_API_TIMEOUT_MS, 20_000),
  refreshStorage: raw.VITE_AUTH_REFRESH_STORAGE === 'session' ? 'session' : 'local',
  defaultPageSize: toNumber(raw.VITE_DEFAULT_PAGE_SIZE, 50),
  isProduction: raw.VITE_APP_ENV === 'production',
} as const
